import { FloorplanFlameDetector } from "@domain/project/floorplan/floorplan-flame-detector";
import { DEFAULT_FLAME_DETECTOR_FIELD_OF_VIEW, FLAME_DETECTOR_FIELD_OF_VIEW } from "@lib/constants/flame_detector_defaults";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { Wedge } from "konva/lib/shapes/Wedge";

export class CoverageAreaConeKonva {
  private static readonly BASE_STROKE_WIDTH = 1;

  static init(flameDetector: FloorplanFlameDetector, fieldOfViewDeg: number): Wedge {
    const wedge = new Wedge({
      radius: flameDetector.coverageAreaLength,
      angle: fieldOfViewDeg,
      rotation: flameDetector.coneRotation - fieldOfViewDeg / 2,
      fill: "#FF660033",
      stroke: "#CC3300",
      strokeWidth: CoverageAreaConeKonva.BASE_STROKE_WIDTH,
    });

    wedge.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, flameDetector);
    return wedge;
  }

  static applyInitialScale(wedge: Wedge, scale: number): void {
    wedge.strokeWidth(CoverageAreaConeKonva.BASE_STROKE_WIDTH * scale);
  }

  static setPosition(wedge: Wedge, parentX: number, parentY: number, parentSize: number): void {
    wedge.x(parentX + parentSize / 2);
    wedge.y(parentY + parentSize / 2);
  }

  static setStrokeWidth(wedge: Wedge, scale: number): void {
    const newStrokeWidth = CoverageAreaConeKonva.BASE_STROKE_WIDTH * scale;
    const previousStrokeWidth = wedge.strokeWidth();
    const strokeDelta = newStrokeWidth - previousStrokeWidth;
    wedge.radius(Math.max(0, wedge.radius() - strokeDelta / 2));
    wedge.strokeWidth(newStrokeWidth);
  }

  static setRadius(wedge: Wedge, radius: number): void {
    wedge.radius(radius);
  }

  static setConeRotation(wedge: Wedge, rotationDeg: number, fieldOfViewDeg: number): void {
    wedge.rotation(rotationDeg - fieldOfViewDeg / 2);
  }

  static getFieldOfView(productName: string): number {
    for (const [family, fov] of Object.entries(FLAME_DETECTOR_FIELD_OF_VIEW)) {
      if (productName.includes(family)) {
        return fov as number;
      }
    }
    return DEFAULT_FLAME_DETECTOR_FIELD_OF_VIEW;
  }
}
